export default Object.freeze({
  EXPECTED: "expected",
  ARRIVED: "arrived",
  CANCELLED: "cancelled",
  SETTLED: "settled"
});
